import React from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import en_US from './locales/en';
import zh_CN from './locales/zh';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux'
import store from './store/store.js';
import LocaleProvider from './utils/LocaleProvider.js';
import posthog from 'posthog-js';

// Initialize PostHog with autocapture disabled (privacy-safe, manual tracking only)
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    autocapture: false,           // Disable automatic event capture
    capture_pageview: false,      // Disable automatic pageview tracking
    disable_session_recording: true, // Disable session recordings
    loaded: (posthog) => {
      posthog.register({ environment: process.env.REACT_APP_ENVIRONMENT || 'unknown' });
      if (process.env.REACT_APP_ENVIRONMENT === 'development') {
        console.log('PostHog initialized (manual tracking only)');
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// // Create browser history to use in the Redux store
// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
// const initialState = window.initialReduxState;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const language = urlParams.get('language');
let locale = window.localStorage.getItem('locale') || "en"
if(language)
  locale = language
const getMessages = (message) => {
  console.log("language is" + message)
  let returnMsg;
  switch (message) {
      case "zh":
          returnMsg = zh_CN;
          break;
      case "en":
          returnMsg = en_US;
          break;
      default:
          returnMsg = en_US;
          break;
  }
  return returnMsg;
}

root.render(
  <React.StrictMode>
    <LocaleProvider>
      <Provider store={store}>
        <App/>
      </Provider>
    </LocaleProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
